import React from "react";
import MarketPlaceLayout from "../components/Layout/MarketPlaceLayout";
import MarketPlace from "../components/MarketPlace";


function MarketPlacePage() {
  return (
      <MarketPlaceLayout>
        <MarketPlace />
      </MarketPlaceLayout>
  );
}

export default MarketPlacePage;
